<template>
<div class="full-wrapper">
  <el-scrollbar :ref="scrollbarRef">
    <div class="full">
      <el-row>
        <w-performance-e2e-analysis-chart :active="active" />
      </el-row>
      <hr class="mr-b20"/>
      <el-row>
        <w-performance-e2e-analysis-table :active="active"/>
      </el-row>
    </div>
  </el-scrollbar>
  <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
</div>
</template>

<script>
import ScrollbarMixin from '@/mixins/scrollbar';
import WPerformanceE2eAnalysisChart from './PerformanceE2eAnalysisChart';
import WPerformanceE2eAnalysisTable from './PerformanceE2eAnalysisTable';

export default {
  name: 'WPerformanceE2eAnaylsis',
  mixins: [ScrollbarMixin],
  components: {
    WPerformanceE2eAnalysisChart,
    WPerformanceE2eAnalysisTable,
  },
  props: {
    active: Boolean,
  },
  mounted() {
    this.setScrollData();
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/e2e/index.vue